<template>
    <div >   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="box"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="标题"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim();}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="video_id"
                    label="视频ID"
                    prop="video_id"
                    :help="formErr.video_id"
                    :validateStatus='!formErr.video_id||formErr.video_id==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.video_id"
                        @change="(e) => { formErr.video_id=''}"
                        @blur="(e) => {  form.video_id = e.target.value.trim();}"
                />
            </a-form-model-item>

            <a-form-model-item
                    ref="thumb"
                    label="封面"
                    prop="thumb"
                    :extra="formErr.thumb"
                    :validateStatus='!formErr.thumb||formErr.thumb==""?"":"error"'
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:1}"
                        :file-list="fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
                <span>建议尺寸：335x192px，不超过1M的jpeg、jpg、png格式的图片</span>
            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="item in this.seleList.status"> {{item.name}} </a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"

    import API from "../api";
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    export default {
        name: "videoForm",
        // props: ["visible","title","editId"],
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},

        },
        data() {
            return {
                contenta: "",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                seleList:[],
                fileList:[],
                previewVisible: false,
                previewImage: "",
                drawerConfig ,
                form: {
                    name:"",
                    video_id:"",
                    thumb:"",
                    status:1,
                },
                formErr: {
                    name:"",
                    video_id:"",
                    thumb:"",
                    status:"",
                },
                rules: {
                    name: [{required: true, message: "请输入标题 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    video_id: [{required: true, message: "请输入视频ID ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.video_id)}  , trigger: "blur"  },],
                     thumb:[{required: true, message: " ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.thumb)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span:3},
                    wrapperCol: { span: 20 },
                },
            };

        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data.info
                        this.form = data
                        if (this.form.thumb == "") {
                            this.fileList = []
                        } else {
                            this.fileList = [
                                {uid: this.form.thumb,
                                    name: this.form.thumb,
                                    status: "done",
                                    url: this.form.thumb ? this.form.thumb : ""
                                }
                            ]
                        }
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        methods: {
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList={
                        status:res.data.data.status,
                    }
                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ) {
                let {fileList} = info;
                const status = info.file.status;

                if (status !== 'uploading') {
                    this.fileList=[]
                }
                if (status === 'done') {
                    this.formErr.thumb=""
                    this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        this.formErr.thumb=""
                        this.fileList= fileList
                    });
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    this.$message.error('只能上传jpeg,jpg，png类型图片!');
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('图片必须小于 1MB!');
                    return false
                }
                return new Promise(function (resolve,reject) {
                    resolve(file)
                })
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onClose() {
                this.$emit("changVisible", false);
                this.fileList=[]
                this.formErr={
                    name:"",
                    video_id:"",
                    thumb:"",
                    status:"",
                }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                if (this.fileList.length < 1) {
                    _this.formErr.thumb = "请上传封面图";

                } else {
                    _this.formErr.thumb = "";
                    this.form.thumb = this.fileList[0].url
                }
                if (this.fileList.length > 0 && this.fileList[0].url) {
                    this.form.thumb = this.fileList[0].url
                } else if (this.fileList.length > 0 && this.fileList[0].response) {
                    this.form.thumb = this.fileList[0].response.data.url
                } else {
                    this.form.thumb = ""
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))

                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 30px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
</style>
